export const SET_DEVICE_FILTERS = 'setDeviceFilters'
export const SET_FLEET_FILTERS = 'setFleetFilters'
export const SET_USER_FILTERS = 'setUserFilters'
export const SET_DRIVER_FILTERS = 'setDriverFilters'
export const SET_ORGANIZATION_FILTERS = 'setOrganizationFilters'

export default {
    setDeviceFilters (state, status) {
        state.devicesManagement.devicesFilters.name = status.name
        state.devicesManagement.devicesFilters.organization = status.organization
        state.devicesManagement.devicesFilters.fleet = status.fleet
        state.devicesManagement.devicesFilters.deviceModelId = status.deviceModelId
        state.devicesManagement.devicesFilters.deviceProtocolId = status.deviceProtocolId
        state.devicesManagement.devicesFilters.simCard = status.simCard
        state.devicesManagement.devicesFilters.vehicle = status.vehicle
        state.devicesManagement.devicesFilters.enabled = status.enabled
        state.devicesManagement.devicesFilters.neverReporter = status.neverReporter
    },
    setFleetFilters (state, status) {
        state.fleetManagement.fleetFilters.organization = status.organization
        state.fleetManagement.fleetFilters.fleet = status.fleet
        state.fleetManagement.fleetFilters.users = status.users
    },
    setUserFilters (state, status) {
        state.userManagement.userFilters.userName = status.userName
        state.userManagement.userFilters.email = status.email
        state.userManagement.userFilters.firstName = status.firstName
        state.userManagement.userFilters.lastName = status.lastName
        state.userManagement.userFilters.organizations = status.organizations
        state.userManagement.userFilters.fleets = status.fleets
    },
    setDriverFilters (state, status) {
        state.driverManagement.driverFilters.name = status.name
        state.driverManagement.driverFilters.phoneNumber = status.phoneNumber
        state.driverManagement.driverFilters.fleets = status.fleets
        state.driverManagement.driverFilters.user = status.user
        state.driverManagement.driverFilters.organizations = status.organizations
    },
    setOrganizationFilters (state, status) {
        state.organizationsManagement.organizationsFilters.name = status.name
        state.organizationsManagement.organizationsFilters.email = status.email
        state.organizationsManagement.organizationsFilters.phone = status.phone
        state.organizationsManagement.organizationsFilters.users = status.users
    }
}
